module.exports = __webpack_public_path__ + "static/videoEN_2-160656fff5b7e62c7d5563d54dde70b4.mp4";